import { updateDataAction, toggleTaskAction } from '../actions/form';
import { refreshStudiesAction } from '../actions/sites';
import { createReducer } from 'redux-create-reducer';

const dirtyReducer = createReducer(false, {
  [updateDataAction]: (state, action) => true,
  [toggleTaskAction]: (state, action) => true,
  [refreshStudiesAction]: (state, action) => true,
});

export default dirtyReducer;

export const getIsDirty = state => state.dirty;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/reducers/dirty.js